import React, { useEffect } from "react";
import { connect } from "react-redux";
// import Layout from "../../components/Layout";
import Create from "../../../components/Meetings/CreateMinutes/Create";
import { mapDispatchToProps } from "../../../store/helpers/mapDispatch";
import { mapStateToProps } from "../../../store/helpers/mapState";
import moment from "moment";
const cheerio = require("cheerio");

const CreateMinute = (props) => {
  const {
    GetVidAndUpdate,
    meetings,
  GetAllMeetings,
    location,
    GetMinutesTemplate,
    minutesTemplate,
    CreateMinutes,
    loggedUser,
    settings,
    resources,
    GetEmployees,
    GetAllResources,
    systemSettings
  } = props;
  const [selectedMeeting, setSelectedMeeting] = React.useState("");
  const [files, setFiles] = React.useState([]);
  const [meeting, setMeeting] = React.useState([]);
  const [content, setContent] = React.useState("");
  const [security, setSecurity] = React.useState("");
  const [listOfAction, setListOfAction] = React.useState([]);

  useEffect(() => {
    const meet = location?.state?.meeting;
    let met = meetings?.find((v) => v?.id === selectedMeeting);
    setMeeting(meet ? meet : met);
  }, [meetings, selectedMeeting]);

  useEffect(() => {
    if (location?.state?.selected) {
      setSelectedMeeting(location.state.selected);
    }
  }, [location?.state?.selected]);

  useEffect(() => GetAllMeetings("All"), [GetAllMeetings]);
  useEffect(() => GetMinutesTemplate(), [GetMinutesTemplate]);
  useEffect(() => {
    GetAllResources();
  }, [])
  useEffect(() => {
    let str = "";
    if (security === "") {
      str = content;
    } else {
      str = minutesTemplate;
    }

    const $ = cheerio.load(str);

    if (meeting.length) {
      $(".document-security").text(security);
      $(".name").text(meeting[0]?.name);
      $(".venue").text(meeting[0]?.venue);
      $(".start").text(moment(meeting[0]?.start).format(
        "DD/MM/yyyy hh:mm a"
      ));
    }
    setContent($.html());
  }, [security]);

  useEffect(() => {
    setContent(minutesTemplate);
  }, [minutesTemplate]);

  const onSubmit = (password) => {
    // e.preventDefault();
    const info = {
      meetingId: selectedMeeting,
      files,
      classification: security,
      password,
      content,
      listOfAction
    };
    return CreateMinutes(info);
  };

  return (
    <div>
      <Create
        GetVidAndUpdate={GetVidAndUpdate}
        loggedUser={loggedUser}
        selectedMeeting={selectedMeeting}
        setFiles={setFiles}
        meetings={meetings}
        onSubmit={onSubmit}
        setSelectedMeeting={setSelectedMeeting}
        meeting={meeting}
        content={content}
        setContent={setContent}
        location={location}
        setSecurity={setSecurity}
        settings={settings}
        resources={resources.data}
        GetEmployees={GetEmployees}
        setListOfAction={setListOfAction}
        listOfAction={listOfAction}
        systemSettings={systemSettings}
      />
    </div>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(CreateMinute);
